import React from "react";
import PropTypes from "prop-types";

import { ColumnHeader } from "./ColumnHeader";
import { TablePropTypes } from "../../propTypes";

const Header = ({
  columns,
  onSortHandler,
  sortColumn,
  onSelectAllHandler,
  selectedAll,
}) => {
  return (
    <thead>
      <tr>
        {columns.map(
          (
            { text, renderHeader, style, sortable, sorter, dataIndex },
            index
          ) => {
            const order =
              sortColumn.column === dataIndex ? sortColumn.order : null;
            return (
              <th
                key={index}
                style={style}
                {...(sortable && { onClick: onSortHandler(dataIndex, sorter) })}
              >
                {renderHeader ? (
                  renderHeader({
                    dataIndex,
                    selectedAll,
                    onSelectAllHandler,
                  })
                ) : (
                  <ColumnHeader sortable={sortable} text={text} order={order} />
                )}
              </th>
            );
          }
        )}
      </tr>
    </thead>
  );
};

Header.propTypes = {
  ...TablePropTypes,
  onSortHandler: PropTypes.func,
  sortColumn: PropTypes.object,
  onSelectAllHandler: PropTypes.func,
  selectedAll: PropTypes.bool,
};

Header.defaultProps = {
  data: [],
  columns: [],
};

export default Header;
